const burger = document.querySelector<HTMLButtonElement>('.site-header__burger');
const panel = document.getElementById('mobile-menu');
const desktop = window.matchMedia('(min-width: 1025px)');

const setOpen = (open: boolean, returnFocus = false) => {
	if (!burger || !panel) return;
	burger.setAttribute('aria-expanded', String(open));
	panel.hidden = !open;
	document.body.classList.toggle('is-menu-open', open);
	if (open) panel.querySelector<HTMLElement>('a, summary')?.focus();
	else if (returnFocus) burger.focus();
};

burger?.addEventListener('click', () => setOpen(burger.getAttribute('aria-expanded') !== 'true'));

const leadDialog = document.querySelector<HTMLDialogElement>('.lead-dialog--start');
const leadPostcode = leadDialog?.querySelector<HTMLInputElement>('[name="postcode"]');
document.querySelectorAll<HTMLAnchorElement>('[data-open-lead-dialog]').forEach((trigger) => {
	trigger.addEventListener('click', (event) => {
		if (!leadDialog) return;
		event.preventDefault();
		setOpen(false);
		if (!leadDialog.open) leadDialog.showModal();
		leadPostcode?.focus();
	});
});

document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape' && burger?.getAttribute('aria-expanded') === 'true') setOpen(false, true);
});

desktop.addEventListener('change', (event) => {
	if (event.matches) setOpen(false);
});

// Mega menus: open on mouse hover (with a short close delay) or via the chevron toggle.
const megaItems = Array.from(document.querySelectorAll<HTMLElement>('.site-nav__item--mega'));
const megaToggle = (item: HTMLElement) => item.querySelector<HTMLButtonElement>('.site-nav__toggle');
let closeTimer: number | undefined;

const setMega = (item: HTMLElement, open: boolean) => {
	item.classList.toggle('is-open', open);
	megaToggle(item)?.setAttribute('aria-expanded', String(open));
};

const openMega = (item: HTMLElement) => {
	window.clearTimeout(closeTimer);
	megaItems.forEach((other) => setMega(other, other === item));
};

const closeAllMega = () => megaItems.forEach((item) => setMega(item, false));

megaItems.forEach((item) => {
	megaToggle(item)?.addEventListener('click', () => (item.classList.contains('is-open') ? setMega(item, false) : openMega(item)));

	item.addEventListener('pointerenter', (event) => {
		if (event.pointerType === 'mouse') openMega(item);
	});

	item.addEventListener('pointerleave', (event) => {
		if (event.pointerType !== 'mouse') return;
		closeTimer = window.setTimeout(() => setMega(item, false), 200);
	});

	item.addEventListener('focusout', (event) => {
		if (!item.contains(event.relatedTarget as Node | null)) setMega(item, false);
	});
});

document.addEventListener('click', (event) => {
	if (!(event.target as Element).closest('.site-nav__item--mega')) closeAllMega();
});

document.addEventListener('keydown', (event) => {
	const open = megaItems.find((item) => item.classList.contains('is-open'));
	if (event.key !== 'Escape' || !open) return;
	setMega(open, false);
	if (open.contains(document.activeElement)) megaToggle(open)?.focus();
});

// Sticky find bar: shown after FIND_BAR_AFTER screens' height of scrolling (0.5 = half a screen), hidden again before the footer.
const FIND_BAR_AFTER = 0.0;
const findBar = document.querySelector<HTMLElement>('.find-bar');
const footer = document.querySelector<HTMLElement>('.site-footer');
let barFrame = 0;

const updateFindBar = () => {
	barFrame = 0;
	if (!findBar || findBar.querySelector('dialog[open]')) return;
	const show = window.scrollY > window.innerHeight * FIND_BAR_AFTER && (!footer || footer.getBoundingClientRect().top > window.innerHeight);
	if (show === findBar.classList.contains('is-visible')) return;
	if (!show && findBar.contains(document.activeElement)) return;
	findBar.classList.toggle('is-visible', show);
	findBar.inert = !show;
};

if (findBar) {
	const schedule = () => { barFrame ||= requestAnimationFrame(updateFindBar); };
	window.addEventListener('scroll', schedule, { passive: true });
	window.addEventListener('resize', schedule);
	updateFindBar();
}
